import React, { useEffect } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import Portal from '@components/Portal/Portal';
import { Dots } from './Dots';
import styles from './ActivityIndicator.module.scss';

export const ActivityIndicator = ({ blockUI = true, selector = '#portal', animation = 'border', ...restProps }) => {
  const validProps = ['as', 'children', 'role', 'size', 'variant', 'bsPrefix'];
  const bootstrapProps = Object.assign({}, ...validProps.map((key) => ({ [key]: restProps[key] })));

  useEffect(() => {
    if (blockUI) {
      document.querySelector('html')?.classList.add(styles.scrollbarFix);
      document.body.classList.add(styles.noScroll);

      return () => {
        document.querySelector('html')?.classList.remove(styles.scrollbarFix);
        document.body.classList.remove(styles.noScroll);
      };
    }
  }, [blockUI]);

  return blockUI ? (
    <Portal selector={selector}>
      <div className={styles.overlay}>
        <Spinner animation={animation} {...bootstrapProps} />
      </div>
    </Portal>
  ) : (
    <Dots />
  );
};
